import React, { Component } from 'react';
import { processSilentRenew } from 'redux-oidc';

import { Loading } from '_components';

class SilentRenewPage extends Component {
  componentDidMount() {
    processSilentRenew();
  }

  render() {
    return (
      <Loading fullscreen />
    );
  }
}

export default SilentRenewPage;
